'use client';
import { getCartSync } from '@/features/cart/model/store';
import { apiClient } from '@/shared/api';
import { FormActionState } from '@/shared/config';
import {
  getApiErrorMessage,
  registerSchema,
  extractFieldErrors,
} from '@/shared/lib';

export async function registerAction(
  prevState: FormActionState,
  formData: FormData,
) {
  const email = formData.get('email');
  const password = formData.get('password');
  const password_confirmation = formData.get('password_confirmation');
  const first_name = formData.get('first_name');
  const last_name = formData.get('last_name');
  const phone = formData.get('phone');
  const policy = formData.get('policy');

  try {
    await registerSchema.validate(
      {
        first_name,
        last_name,
        phone,
        email,
        password,
        password_confirmation,
        policy,
      },
      { abortEarly: false },
    );

    await getCartSync().runBoundary('session', () =>
      apiClient('register', {
        method: 'POST',
        body: JSON.stringify({
          first_name,
          last_name,
          phone,
          email,
          password,
          password_confirmation,
        }),
      }),
    );

    return {
      ...prevState,
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error),
      fieldErrors: extractFieldErrors(error),
    };
  }
}
